<template>
  <v-card class="px-2 py-8 item" height="100%" flat tile>
    <div
      class="
        primary--text
        text-subtitle-1 text-md-h6 text-center
        font-weight-bold
        px-1
        item-title
      "
    >
      {{ title }}
    </div>

    <img
      class="d-block mt-3 item-img"
      :src="files + img"
      :alt="title"
      width="100%"
    />

    <div
      v-if="text"
      class="grey--text text--darken-1 text-center mt-4"
      v-html="text"
    ></div>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid #d9d9d9;

  &-title {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: 48px;
    -webkit-line-clamp: 3;
    line-height: 1.2;
    overflow: hidden;
  }

  &-img {
    aspect-ratio: 16 / 9;
    -o-object-fit: contain;
    object-fit: contain;
  }
}
</style>
